module.exports = __webpack_public_path__ + "static/media/pending.f6e7cd66.svg";